/**
 * Shared utility for distinguishing note messages from chat messages.
 * Notes are stored in the same `messages` table as chat messages,
 * differentiated only by emoji prefixes in message_content.
 */

const NOTE_PREFIXES = [
  '📝 Client Note:',
  '📋 Personal Health Notes:',
  '🤖 AI Health Summary:',
];

export function isNoteMessage(messageContent: string | null | undefined): boolean {
  if (!messageContent) return false;
  return NOTE_PREFIXES.some(prefix => messageContent.startsWith(prefix));
}
